var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocket = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 12,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.873 8.741a4.474 4.474 0 0 1 5.22-7.2M1.304 8.71C.736 9.705.545 10.48.866 10.8c.488.487 2.013-.202 3.78-1.602m2.021-.354L4.99 7.166m1.678 1.678 3.73-3.73c.304-.304.52-.686.624-1.103l.24-.96a.396.396 0 0 0-.48-.48l-.96.241a2.37 2.37 0 0 0-1.102.624l-3.73 3.73m1.678 1.678.458 1.375a.197.197 0 0 0 .328.077l.48-.479a1.59 1.59 0 0 0 .382-1.623l-.25-.75zM4.99 7.166l-1.374-.458a.198.198 0 0 1-.078-.328l.48-.48a1.59 1.59 0 0 1 1.622-.382l.75.249z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 12,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.873 8.741a4.474 4.474 0 0 1 5.22-7.2M1.304 8.71C.736 9.705.545 10.48.866 10.8c.488.487 2.013-.202 3.78-1.602m2.021-.354L4.99 7.166m1.678 1.678 3.73-3.73c.304-.304.52-.686.624-1.103l.24-.96a.396.396 0 0 0-.48-.48l-.96.241a2.37 2.37 0 0 0-1.102.624l-3.73 3.73m1.678 1.678.458 1.375a.197.197 0 0 0 .328.077l.48-.479a1.59 1.59 0 0 0 .382-1.623l-.25-.75zM4.99 7.166l-1.374-.458a.198.198 0 0 1-.078-.328l.48-.48a1.59 1.59 0 0 1 1.622-.382l.75.249z"
  }));
});
export default SvgIconRocket;
export const raw = __webpack_public_path__ + "static/media/IconRocket.23e1ad3ad1c8391119ac869f2f157b98.svg";